import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";


export const FollowerCardElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  methods: {
    getExampleEntity() {
      return {
        "orgId": 0,
        "name": "John Smith",
        "orgDescription": "",
        "logoUrl": "https://inspirationprod.blob.core.windows.net/inspiration-cdn/images/john-smith-profile-picture.webp",
        "status": "active",
        "visibility": true,
        "isFollowing": false,
      };
    },
    getRealEntity() {
      return this.getExampleEntity();
    },
  },
};
